
import { Button } from "@/components/ui/button";
import { Drawer, DrawerClose, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { FilterContainer } from "./filters/FilterContainer";

interface MobileFilterDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters: {
    searchQuery: string;
    locationFilter: string;
    skillFilter: string;
    companyFilter: string;
    roleFilter: string;
    workArrangementFilter: string;
    salaryRange: [number, number];
    industryFilter: string;
  };
  setters: {
    setSearchQuery: (value: string) => void;
    setLocationFilter: (value: string) => void;
    setSkillFilter: (value: string) => void;
    setCompanyFilter: (value: string) => void;
    setRoleFilter: (value: string) => void;
    setWorkArrangementFilter: (value: string) => void;
    setSalaryRange: (value: [number, number]) => void;
    setIndustryFilter: (value: string) => void;
  };
  onApplyFilters: () => void;
  onResetFilters: () => void;
  uniqueLocations: string[];
  uniqueIndustries: string[];
  uniqueSkills: string[];
  uniqueCompanies: string[];
}

export function MobileFilterDrawer({
  open,
  onOpenChange,
  filters,
  setters,
  onApplyFilters,
  onResetFilters,
  uniqueLocations,
  uniqueIndustries,
  uniqueSkills,
  uniqueCompanies
}: MobileFilterDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-4 pb-6 pt-2 max-h-[85dvh]">
        <DrawerHeader className="p-4">
          <DrawerTitle>Filters</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 overflow-y-auto">
          <FilterContainer
            searchQuery={filters.searchQuery}
            onSearchChange={setters.setSearchQuery}
            industryFilter={filters.industryFilter}
            onIndustryChange={setters.setIndustryFilter}
            locationFilter={filters.locationFilter}
            onLocationChange={setters.setLocationFilter}
            sizeFilter=""
            onSizeFilter={() => {}}
            skillFilter={filters.skillFilter}
            onSkillChange={setters.setSkillFilter}
            companyFilter={filters.companyFilter}
            onCompanyChange={setters.setCompanyFilter}
            roleFilter={filters.roleFilter}
            onRoleChange={setters.setRoleFilter}
            workArrangementFilter={filters.workArrangementFilter}
            onWorkArrangementChange={setters.setWorkArrangementFilter}
            salaryRange={filters.salaryRange}
            onSalaryRangeChange={setters.setSalaryRange}
            onApplyFilters={() => {
              onApplyFilters();
              onOpenChange(false);
            }}
            onResetFilters={onResetFilters}
            uniqueLocations={uniqueLocations}
            uniqueIndustries={uniqueIndustries}
            uniqueSkills={uniqueSkills}
            uniqueCompanies={uniqueCompanies}
          />
        </div>
        <DrawerFooter className="px-4 pt-2">
          <DrawerClose asChild>
            <Button variant="outline">Close</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
